import React from 'react';
import config from '../../config';

const GiftDisclaimer = () => (
  <p className="disclaimer">
    {'Gift Cards are subject to '}
    <DisclaimerLink url={config.termsConditions} text="Terms of Use" />.
    {'  Gift Cards are not returnable after purchase (except as required by law).'}
    {'  Have a gift card? '}
    <DisclaimerLink url="/redeem" text="Redeem" />
    {' your gift card.'}
  </p>
);

const DisclaimerLink = ({ text, url }) => (
  <a
    className="disclaimer-link"
    href={url}
    target="_blank"
    rel="noopener noreferrer"
  >
    {text}
  </a>
);

export default GiftDisclaimer;
